<app-loading-overlay
  class="firms-table-loader"
  [loading]="showLoadingOverlay()"
>
  <table
    appTable
    appTableSort
    class="firms-table"
    [dataSource]="rows()"
    [appTableSortDisabled]="disableSorting()"
    [appTableSortActive]="orderBy() ?? ''"
    [appTableSortDirection]="orderDir() ?? ''"
    (sortChange)="onSortChange($event)"
  >
    <ng-container appTableColumnDef="name">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
        appTableSortHeader="name"
      >
        {{ 'entities.firm.table.header.name' | translate }}
      </th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="70%"
            height="1.25rem"
          />
        } @else {
          {{ firm.name }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="address">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.firm.table.header.address' | translate }}
      </th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="80%"
            height="1.25rem"
          />
        } @else {
          {{ firm.address || '-' }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="phone">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.firm.table.header.phone' | translate }}
      </th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="65%"
            height="1.25rem"
          />
        } @else {
          {{ firm.phone | phoneFormat }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="email">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.firm.table.header.email' | translate }}
      </th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="75%"
            height="1.25rem"
          />
        } @else {
          {{ firm.email || '-' }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="contactName">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      >
        {{ 'entities.firm.table.header.contactName' | translate }}
      </th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton
            width="70%"
            height="1.25rem"
          />
        } @else {
          {{ firm.contactName || '-' }}
        }
      </td>
    </ng-container>

    <ng-container appTableColumnDef="actions">
      <th
        *appTableHeaderCellDef
        appTableHeaderCell
      ></th>
      <td
        *appTableCellDef="let firm"
        appTableCell
      >
        @if (isInitialLoad()) {
          <p-skeleton size="2rem" />
        } @else {
          <app-table-row-actions-button
            [item]="firm"
            [actions]="rowActions()"
          />
        }
      </td>
    </ng-container>

    <tr
      *appTableHeaderRowDef="displayedColumns(); sticky: true"
      appTableHeaderRow
    ></tr>
    <tr
      *appTableRowDef="let row; columns: displayedColumns()"
      appTableRow
    ></tr>
    <tr *appTableNoDataRow>
      <td [attr.colspan]="displayedColumns().length">
        @switch (contentState()) {
          @case ('empty') {
            <ng-container *ngTemplateOutlet="emptyTpl() ?? defaultNoData" />
          }
          @case ('noResults') {
            <ng-container *ngTemplateOutlet="noResultsTpl() ?? defaultNoData" />
          }
          @case ('error') {
            <ng-container *ngTemplateOutlet="errorTpl() ?? defaultNoData" />
          }
        }
      </td>
    </tr>
  </table>
</app-loading-overlay>

<ng-template #defaultNoData>
  <app-table-state-card [title]="defaultNoDataTitleKey() | translate" />
</ng-template>
